import { general } from './general'
import { taxRate } from './taxRate'
import { unionLocal } from './unionLocal'
import { fegli } from './fegli'
import { dental } from './dental'
import { vision } from './vision'
import { fehb } from './fehb'
import { sickLeaveLookup } from './sickLeaveLookup'
export default {
  ...general,
  taxRate,
  unionLocal,
  fegli,
  dental,
  vision,
  fehb,
  sickLeaveLookup,
}
